var map = {
	"./al-shiddi.png": "22be",
	"./caparol.png": "0099",
	"./dukat.png": "eac3",
	"./fly-bosnia.png": "d7e5",
	"./hydrometal.png": "9b59",
	"./lactalis.png": "a5f5",
	"./orbico.png": "73bb",
	"./orman.png": "a70a",
	"./plus.png": "a691",
	"./sarajklima.png": "470f",
	"./senigor.png": "feaa",
	"./sprind.png": "4ac5",
	"./vipox.png": "c61f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38b6";